import React from 'react';
import JobBoardMobile from '../AllTutors/JobBoardMobile/JobBoardMobile';

const TutorJobBoardInnerMobile = () => {
    return (
        <div>
            <JobBoardMobile></JobBoardMobile>
        </div>
    );
};

export default TutorJobBoardInnerMobile;